import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

import BPartsBicon from '../../ui/icons/bparts-b-icon';
import BPImage from '../../ui/v2/image';

import classes from './banner.module.css';

const Banner: FunctionComponent = () => {
  const { t } = useTranslation();
  return (
    <section
      className={cx(
        classes.banner,
        'relative',
        'flex',
        'flex-col',
        'justify-end',
        'items-center',
        'text-white',
        'p-4',
        '-mt-2',
        'mb-12',
        'lg:p-0'
      )}
    >
      <BPImage
        src={`${process.env.PUBLIC_PREFIX}/img/about/banner.jpg`}
        layout="fill"
        style={{ objectFit: 'cover' }}
        placeholder="empty"
        alt={t('about:banner.imgAlt')}
      />
      {t('about:banner.title') && (
        <h1
          className={cx(
            classes.title,
            'font-extrabold',
            'text-center',
            'uppercase',
            'text-5xl',
            'z-10',
            'py-20'
          )}
        >
          {t('about:banner.title')}
        </h1>
      )}
    </section>
  );
};

export default Banner;
